import {createAction, props} from '@ngrx/store';

//#region Heartbeat Start

/**
 * Starts the heartbeat monitoring mechanism.
 *
 * This action is dispatched once to initiate the heartbeat system,
 * which begins tracking user activity and triggers heartbeat intervals.
 *
 * @constant
 */
export const startHeartbeat = createAction(
  '[HEARTBEAT][Enable] Start Heartbeat',
);

//#endregion

//#region Heartbeat Application On User Activity

/**
 * Dispatches a heartbeat pulse triggered by recent user activity.
 *
 * This action includes a timestamp indicating the latest activity,
 * used to track session freshness and continuous presence.
 *
 * @param heartBeat - The current timestamp (e.g., `Date.now()`) representing user activity.
 * @constant
 */
export const heartBeatApplicationOnUserActivity = createAction(
  '[HEARTBEAT][Application] Heartbeat Application On User Activity',
  props<{ heartBeat: number }>(),
);

//#endregion

//#region Heartbeat Inactivity

/**
 * Signals that the user has been inactive beyond the configured timeout.
 *
 * This action is triggered when no user interaction is detected for a prolonged period,
 * potentially indicating session expiration or user abandonment.
 *
 * @constant
 */
export const heartBeatInactivityTriggered = createAction(
  '[HEARTBEAT][Inactivity] Heartbeat Application Inactivity Triggered',
);

//#endregion
